import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const tenantMenuRegistry = {
    core_tenant: {
        label: "Tenant",
        link: PAGE_URL.TENANT_PAGE,
        key: PAGE_URL.TENANT_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default tenantMenuRegistry;
